import React from "react";
import { useHistory } from "react-router-dom";
import Layout from "../../../Layouts/Resources/Layout";
import WaitingFor from "components/Banner/WaitingFor";
import classes from "./GrantsLandingPage.module.css";
import { getData } from "app/data";

const Index = () => {
  const history = useHistory();

  return (
    <>
      <Layout titleId="grants_title" subtitleId="grants_subtitle">
        <div
          className={classes["card-godigital"]}
          onClick={() => {
            history.push("/godigital");
          }}
        >
          <div className={classes["card-godigital-title-container"]}>
            <p className={classes["card-godigital-title"]}>
              {getData("grants").card1.title}
            </p>
            <div className={classes["card-godigital-subtitle"]}>
              <span className={classes["card-godigital-subtitle-white"]}>
                {getData("grants").card1.subtitleWhite}
              </span>
              <span className={classes["card-godigital-subtitle-yellow"]}>
                {getData("grants").card1.subtitleYellow}
              </span>
            </div>
          </div>
        </div>

        <div
          className={classes["card-techup"]}
          onClick={() => {
            history.push("/techup");
          }}
        >
          <div className={classes["card-techup-title-container"]}>
            <p className={classes["card-techup-title"]}>
              {getData("grants").card2.title}
            </p>
            <p className={classes["card-techup-subtitle"]}>
              {getData("grants").card2.subtitle}
            </p>
          </div>
        </div>

        <div
          className={classes["card-powerup"]}
          // onClick={() => {
          //   history.push("/powerup");
          // }}
        >
          <div className={classes["card-powerup-title-container"]}>
            <p className={classes["card-powerup-title"]}>
              {getData("grants").card3.title}
            </p>
            <div className={classes["card-powerup-subtitle"]}>
              <span className={classes["card-powerup-subtitle-yellow"]}>
                {getData("grants").card3.subtitleYellow}
              </span>
              <span className={classes["card-powerup-subtitle-white"]}>
                {getData("grants").card3.subtitleWhite}
              </span>
            </div>
          </div>
        </div>
      </Layout>
      <WaitingFor />
    </>
  );
};

export default Index;
